module.exports = __webpack_public_path__ + "static/media/artstation.526e4d0c.svg";